<template>
<report-list-page
    v-if="checkAccess('invoices')"
    page-title="Invoice Report"
    page-icon="transform"
    :status-arr="statusArr"
    :descending="true"
    :headers="headers"
    state-end-point="invoice.invoices"
    :actions="actions"
    :show-component="showComponent"
/>
</template>

<script>
import IsAuthenticated from "../../middleware/IsAuthenticated";
import ReportListPage from "../../components/ReportListPage";
export default {
  name: "InvoiceReport",
  components: {ReportListPage},
  mixins: [IsAuthenticated],
  data() {
    return {
      headers: [
        {
          text: 'ID',
          value: 'invoiceNo'
        },
        {
          text: 'Date',
          value: 'createdAt'
        },
        {
          text: 'Email',
          value: 'email'
        },
        {
          text: 'Status',
          align: 'left',
          value: 'paymentStatus'
        },
        {
          text: 'Is Deleted?',
          value: 'isDeleted'
        },
        {
          text: 'Invoice Details',
          align: 'left',
          value: 'invoiceDetails'
        },
        {
          text: 'Payment Details',
          align: 'left',
          value: 'paymentDetails'
        },
        {
          text: 'Total',
          align: 'right',
          value: 'amount'
        },
        {
          text: 'Discount',
          align: 'right',
          value: 'discount'
        },
        {
          text: 'T. Amount',
          align: 'right',
          value: 'totalAmount'
        }
      ],
      actions: {
        load: 'loadInvoices',
      },
      statusArr: [
        {name: 'Unpaid', id: 100},
        {name: 'Paid', id: 200},
        {name: 'Deleted', id: 500}
      ],
      showComponent: {
        isUser: true,
        isStatus: true,
        isMethod: true,
        isEmail: true,
      }
    }
  }
}
</script>

<style scoped>

</style>